import React, { useRef ,useState ,useEffect} from "react";
import Header from "../Header/Header";
import SectionWrapper from "../common/SectionWrapper/SectionWrapper";
import TicketList from "../TicketList/TicketList";
import TimelineBlock from "../TimelineBlock/TimelineBlock";
import Footer from "../Footer/Footer";
import Hero from "../Hero/Hero";
import DreamDraw from "../DreamDraw/DreamDraw";
import CharityBlock from "../CharityBlock/CharityBlock";
import MobileCTAButtonBottom from "../mobile-cta-button-bottom";
import TicketSelector from "../TicketSelector/TicketSelector";
import "./styles.css";

const Main = (props) => {
  const {
    prizeId,
    raffles,
    raffle,
    activeRaffles,
    subscriptionModels,
    data,
    onCTAClick,
    onTwo4One,
    onLearnMoreClick,
    onLearnMoreCharityClick,
    widgets,
    content,
    bonusDraw,
  } = props;
  const ticketSelectorRef = useRef(null);
  const [isDouble, setIsDouble] = useState(false);

    useEffect(() => {
      if (props.raffles && props.raffles.length > 1) {
        setIsDouble(true);
      }
    }, [props.raffles]);
  return (
    <>
      {prizeId ? (
        <div className="app">
          <Header raffle={raffle} />
          <main>
            <Hero onCTAClick={onCTAClick} onTwo4One={onTwo4One} content={content} raffles={raffles}/>
            <MobileCTAButtonBottom
              variant='variant-2'
              currentRaffle={raffle}
              withCountdown
              raffles={activeRaffles.length > 0 ? activeRaffles : raffles}
            />
            {/* <SectionWrapper bg="bg-2">
              {isDouble && ( 
                  <div className="update__2-4-1">
                    <button className="update-buttons__2-4-1-btn" onClick={onTwo4One} >
                      
                      <p>View 2-4-1 Home Offer</p>
                    </button> 
                  </div>
                ) 
                }
            </SectionWrapper> */}
            <SectionWrapper bg="bg-2">
              <TicketSelector
                reference={ticketSelectorRef}
                title={data.ticketSelector.title}
                subtitle={content.dreamHome.timeLine.description}
                prizeId={prizeId}
                subscriptionModels={subscriptionModels}
                raffles={activeRaffles.length > 0 ? activeRaffles : raffles}
                currentRaffle={raffle}
                theme="light"
                bonusDraw={bonusDraw}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-1">
              <CharityBlock
                onCTAClick={onCTAClick}
                onLearnMoreClick={onLearnMoreClick}
                onLearnMoreCharityClick={onLearnMoreCharityClick}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-2">
              <TimelineBlock
                onCTAClick={onCTAClick}
                content={content.dreamHome.timeLine}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-1">
              <div className="footer-margin"></div>
            </SectionWrapper>
            <Footer insideComponent={true} widget={widgets.footerWidget} bonusDraw={bonusDraw} />
          </main>
        </div>
      ) : (
        <main className="no-prize">
          <h1>No prize</h1>
        </main>
      )}
    </>
  );
};

export default Main;
